import { useScroll } from 'hooks/scroll';
import React, { useEffect, useRef } from 'react';
import { animated, useSprings, UseSpringProps } from 'react-spring';
import * as d3 from 'd3-ease';

const easingAnimate = undefined;

const springConfig = {
    mass: 1,
    tension: 177,
    friction: 29,
};

export const BgNewPath = () => {
    const isScrollControl = useRef(false);

    const pathTotalLengthList = useRef<number[]>([
        397.7385, 376.7384, 1131.5766, 1181.5527, 351.6383, 174.0299,
    ]);

    function initPathRef() {
        let i = 1;
        pathTotalLengthList.current = [];
        pathTotalLengthList.current.length = 6;
        while (i <= 6) {
            const el = document.getElementById(`bg-path-${i}`) as unknown as SVGPathElement;
            const len = el.getTotalLength();
            if (i == 3) {
                el.style.strokeDasharray = `${len * 1.4}px ${2 * len}px`;
            } else {
                el.style.strokeDasharray = `${len - 3}px ${2 * len}px`;
            }
            pathTotalLengthList.current[i - 1] = Math.floor(len) + 1;
            i++;
        }
    }
    function generateAnimate(process: number): (i: number) => UseSpringProps<React.CSSProperties> {
        const pathLengthList = pathTotalLengthList.current;
        if (process < 0) {
            return (i) => {
                let initOffset = pathLengthList[i];
                if (i === 2) {
                    return {
                        strokeDashoffset: `${1.4 * initOffset}px`,
                        immediate: true,
                    };
                } else {
                    return {
                        strokeDashoffset: `${initOffset}px`,
                        immediate: true,
                    };
                }
            };
        } else if (process >= 0 && process <= 100) {
            // 曲线出现
            return (i) => {
                const len = pathLengthList[i];
                if (i === 0 || i === 1) {
                    return {
                        strokeDashoffset: '0px',
                        config: {
                            easing: easingAnimate,
                            // duration: i === 0 ? 1800 : 2600,
                            friction: 59,
                        },
                        delay: i == 0 ? 400 : 400,
                        immediate: false,
                    };
                } else if (i === 2) {
                    return {
                        strokeDashoffset: `0px`,
                        config: {
                            easing(t) {
                                return Math.sqrt(d3.easeCubicOut(t));
                            },
                            duration: 7000,
                        },
                        delay: 100,
                        immediate: false,
                    };
                } else if (i === 4 || i === 5) {
                    return {
                        strokeDashoffset: '0px',
                        config: {
                            friction: i === 4 ? 40 : 60,
                            tension: 200,
                        },
                        delay: i === 4 ? 1600 : 1600,
                        immediate: false,
                    };
                } else if (i === 3) {
                    return {
                        strokeDashoffset: `-10px`,
                        config: {
                            tension: 50,
                        },
                        delay: -100,
                        immediate: false,
                    };
                }
            };
        } else if (process > 100 && process <= 200) {
            // 消失
            return (i) => {
                const len = pathLengthList[i];
                const processRate = (process - 100) / 100;
                if (i === 0 || i === 1) {
                    return {
                        strokeDashoffset: `${-processRate * 6 * len}px`,
                        config: {
                            ...springConfig,
                        },
                        immediate: false,
                    };
                } else if (i === 2) {
                    return {
                        strokeDashoffset: `${-processRate * 2 * len}px`,
                        config: {
                            ...springConfig,
                        },
                        immediate: false,
                    };
                } else if (i === 4 || i === 5) {
                    if (processRate > 0.5) {
                        return {
                            strokeDashoffset: `${-processRate * len * 2}px`,
                            config: {
                                ...springConfig,
                            },
                            immediate: false,
                        };
                    } else if (processRate < 0.5)
                        return {
                            strokeDashoffset: `0px`,
                            config: {
                                ...springConfig,
                            },
                            immediate: false,
                        };
                    return;
                } else if (i === 3) {
                    return {
                        strokeDashoffset: `${-processRate * 2 * len}px`,
                        config: {
                            ...springConfig,
                        },
                        immediate: false,
                    };
                }
            };
        } else if (process > 200) {
            return (i) => {
                const len = pathLengthList[i];
                return {
                    strokeDashoffset: `${-2 * len + 10}`,
                    immediate: true,
                };
            };
        }
    }

    useEffect(() => {
        initPathRef();
        //@ts-expect-error
        setPateAnimate(generateAnimate(-1));
    }, []);

    //@ts-expect-error
    const [pathAnimates, setPateAnimate, stopAnimate] = useSprings(6, (i) => ({
        strokeDashoffset: `${pathTotalLengthList.current[i]}px`,
    }));

    useEffect(() => {
        setTimeout(() => {
            //@ts-expect-error
            setPateAnimate(generateAnimate(100));
            setTimeout(() => {
                isScrollControl.current = true;
            }, 3000);
        }, 300);
    }, []);

    useScroll(() => {
        if (!isScrollControl.current) {
            return;
        }
        const scaleWindow = Math.max(1, window.innerWidth / 1920);
        const scrollHeight = 1000 * scaleWindow;
        const scrollY = window.scrollY + 10;
        if (scrollY <= scrollHeight) {
            const process = scrollY / scrollHeight + 1;
            //@ts-expect-error
            setPateAnimate(generateAnimate(process * 100));
        } else {
            //@ts-expect-error
            setPateAnimate(generateAnimate(999));
        }
    }, 100);

    return (
        <>
            <svg width="1933px" height="897px" viewBox="0 0 1933 897" version="1.1">
                <g
                    id="首页"
                    transform="translate(-125, -22)"
                    stroke="none"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                    strokeWidth="4"
                >
                    <animated.path
                        d="M1043.73271,104 L1251.73271,104 C1253.94185,104 1255.73271,105.790861 1255.73271,108 L1255.73271,291.454362 L1255.73271,291.454362"
                        id="bg-path-1"
                        style={pathAnimates[0]}
                        stroke="#1DD1E2"
                        transform="translate(1149.732708, 197.727181) rotate(-22) translate(-1149.732708, -197.727181) "
                    />
                    <animated.path
                        d="M979.732708,128 L1191.73271,128 C1193.94185,128 1195.73271,129.790861 1195.73271,132 L1195.73271,290.454362 L1195.73271,290.454362"
                        id="bg-path-2"
                        style={pathAnimates[1]}
                        stroke="#0075FF"
                        strokeLinejoin="round"
                        transform="translate(1087.732708, 209.227181) rotate(-22) translate(-1087.732708, -209.227181) "
                    />
                    <animated.path
                        d="M-9.0350797,615.131406 L354.131379,615.131406 C356.340518,615.131406 358.131379,616.922267 358.131379,619.131406 L358.131379,760.064252 C358.131379,762.273391 359.92224,764.064252 362.131379,764.064252 L1027.01651,764.064252 L1027.01651,764.064252"
                        id="bg-path-3"
                        style={pathAnimates[2]}
                        stroke="#0075FF"
                        strokeLinejoin="round"
                        transform="translate(508.990715, 689.597829) rotate(-22) translate(-508.990715, -693) "
                    />
                    <animated.path
                        d="M 2119.44916 467.86787 C 2121.37544 468.19162 2122.78618 469.859253 2122.78618 471.812544 C 2122.78618 474.021683 2120.99532 475.812544 2118.78618 475.812544 L 1341.47826 475.812544 C 1339.26912 475.812544 1337.47826 474.021683 1337.47826 471.812544 L 1337.47826 311.314579 C 1337.47826 309.10544 1335.6874 307.314579 1333.47826 307.314579 L 1164.17747 307.314579"
                        id="bg-path-4"
                        style={pathAnimates[3]}
                        stroke="#1DD1E2"
                        strokeLinejoin="round"
                        transform="translate(1665.448216, 391.563561) rotate(-22) translate(-1665.448216, -392.563561) "
                    />
                </g>
            </svg>
            <BtnPath path1={pathAnimates[4]} path2={pathAnimates[5]} />
        </>
    );
};

export default BgNewPath;

export interface BtnPathProps {
    path1: React.CSSProperties;
    path2: React.CSSProperties;
}
export function BtnPath(props: BtnPathProps) {
    const { path1, path2 } = props;
    return (
        <div className="btn-path">
            <svg width="160px" height="56px" viewBox="0 0 160 56" version="1.1">
                <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                >
                    <g
                        id="首页-new"
                        transform="translate(-882.000000, -613.000000)"
                        strokeWidth="4"
                    >
                        <g id="slogan-&amp;-lines" transform="translate(-37.000000, 83.000000)">
                            <g id="btn" transform="translate(921.000000, 532.000000)">
                                <animated.path
                                    style={path1}
                                    d="M 34.8842405 52 C 56.021076 52 87.7263291 52 130 52 C 144.359403 52 156 40.3594035 156 26 C 156 11.6405965 144.359403 0 130 0 L 26 0 C 11.6405965 0 0 11.6405965 0 26 C 0 40.3594035 11.6405965 52 26 52"
                                    id="bg-path-5"
                                    stroke="#1DD1E2"
                                />
                                <animated.path
                                    style={path2}
                                    d="M 8.14198368 44.8969472 C 12.7996934 49.3001289 19.0845524 52 26 52 L 130 52 C 144.359403 52 156 40.3594035 156 26 C 156 11.6405965 144.359403 0 130 0"
                                    id="bg-path-6"
                                    stroke="#0075FF"
                                    strokeLinejoin="round"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
}
